import React, { useState, useEffect } from 'react';

import './style.scss';

const Caption = ({ content, maxWords = 6 }) => {
    const [showMore, setShowMore] = useState(false);
    const [shortCaption, setShortCaption] = useState('');

    useEffect(() => {
        if (content && content.split(" ").length > maxWords) {
            setShortCaption(truncate(content, maxWords));
        } else {
            setShortCaption('');
        }
    }, [content]);

    const toggleShowCaption = e => {
        e.preventDefault();
        setShowMore(showMore => !showMore);
    };

    const truncate = (str, maxWords) => {
        return str.split(" ").splice(0, maxWords).join(" ");
    };

    if (shortCaption && !showMore) {
        return <React.Fragment>
            <div
                style={{ display: 'inline', fontWeight: 'normal', whiteSpace: 'pre-wrap' }}
                dangerouslySetInnerHTML={{ __html: shortCaption }}
            />... <a href="#" onClick={toggleShowCaption}>Read more</a>
        </React.Fragment>;
    } else if (shortCaption && showMore) {
        return <React.Fragment>
            <div
                style={{ display: 'inline', fontWeight: 'normal', whiteSpace: 'pre-wrap' }}
                dangerouslySetInnerHTML={{ __html: content }}
            /> <a href="#" onClick={toggleShowCaption}>Read less</a>
        </React.Fragment>;
    } else {
        return <React.Fragment>
            <div
                style={{ display: 'inline', whiteSpace: 'pre-wrap' }}
                dangerouslySetInnerHTML={{ __html: content }}
            />
        </React.Fragment>;
    }
};

export default Caption;